<template>
  <div class="news-detail-page">
    <div class="news-hero">
      <img src="@/assets/images/新闻背景.jpg" alt="头图" />
      <div class="hero-text">
        <h1>品牌新闻<span class="en-title"> / NEWS CENTER</span></h1>
      </div>
    </div>

    <div class="news-detail-content">
      <h2>{{ $t('news.fw2024.title') }}</h2>
      <p class="meta">2024-10-26 ｜ 👁 1182</p>

      <img src="@/assets/images/allnews/news24fw/24FW-1.jpg" alt="2024FW 封面" />
      <p>{{ $t('news.fw2024.content1') }}</p>
      <p>{{ $t('news.fw2024.content2') }}</p>
      <img src="@/assets/images/allnews/news24fw/24FW-2.jpg" alt="2024FW 封面" />
      <p>{{ $t('news.fw2024.content3') }}</p>
      <img src="@/assets/images/allnews/news24fw/24FW-3.jpg" alt="2024FW 封面" />
      <img src="@/assets/images/allnews/news24fw/24FW-4.jpg" alt="2024FW 封面" />
      <img src="@/assets/images/allnews/news24fw/24FW-5.jpg" alt="2024FW 封面" />
      <p>{{ $t('news.fw2024.content4') }}</p>
      <p>{{ $t('news.fw2024.content5') }}</p>
     <p>{{ $t('news.fw2024.content6') }}</p>
      <p>{{ $t('news.fw2024.content7') }}</p>
      <img src="@/assets/images/allnews/news24fw/24FW-6.jpg" alt="2024FW 封面" />
      <p>{{ $t('news.fw2024.content8') }}</p>
      <img src="@/assets/images/allnews/news24fw/24FW-7.jpg" alt="2024FW 封面" />
      <p>{{ $t('news.fw2024.content9') }}</p>
      <p>{{ $t('news.fw2024.content10') }}</p>
      <img src="@/assets/images/allnews/news24fw/24FW-8.jpg" alt="2024FW 封面" />
      <p>{{ $t('news.fw2024.content11') }}</p>
      <img src="@/assets/images/allnews/news24fw/24FW-9.jpg" alt="2024FW 封面" />
      <img src="@/assets/images/allnews/news24fw/24FW-10.jpg" alt="2024FW 封面" />
      <p>{{ $t('news.fw2024.content12') }}</p>
      <img src="@/assets/images/allnews/news24fw/24FW-11.jpg" alt="2024FW 封面" />
      <p>{{ $t('news.fw2024.content13') }}</p>
     <p>{{ $t('news.fw2024.content14') }}</p>
      <p>{{ $t('news.fw2024.content15') }}</p>
      <img src="@/assets/images/allnews/news24fw/24FW-12.jpg" alt="2024FW 封面" />
      <img src="@/assets/images/allnews/news24fw/24FW-13.jpg" alt="2024FW 封面" />
      <img src="@/assets/images/allnews/news24fw/24FW-14.jpg" alt="2024FW 封面" />
      <img src="@/assets/images/allnews/news24fw/24FW-15.jpg" alt="2024FW 封面" />
      <p>{{ $t('news.fw2024.content16') }}</p>
      <p>{{ $t('news.fw2024.content17') }}</p>
      <img src="@/assets/images/allnews/news24fw/24FW-16.jpg" alt="2024FW 封面" />
      <img src="@/assets/images/allnews/news24fw/24FW-17.jpg" alt="2024FW 封面" />
      <img src="@/assets/images/allnews/news24fw/24FW-18.jpg" alt="2024FW 封面" />
      <img src="@/assets/images/allnews/news24fw/24FW-19.jpg" alt="2024FW 封面" />
      <p>{{ $t('news.fw2024.content18') }}</p>
      <p>{{ $t('news.fw2024.content19') }}</p>
      <p>{{ $t('news.fw2024.content20') }}</p>
      <img src="@/assets/images/allnews/news24fw/24FW-20.jpg" alt="2024FW 封面" />
      <p>{{ $t('news.fw2024.content21') }}</p>
      <p>{{ $t('news.fw2024.content22') }}</p>
      <p>{{ $t('news.fw2024.content23') }}</p>
      <img src="@/assets/images/allnews/news24fw/24FW-21.jpg" alt="2024FW 封面" />
      <p>{{ $t('news.fw2024.content24') }}</p>
      <p>{{ $t('news.fw2024.content25') }}</p>
      <img src="@/assets/images/allnews/news24fw/24FW-22.jpg" alt="2024FW 封面" />
      <p>{{ $t('news.fw2024.content26') }}</p>
      <img src="@/assets/images/allnews/news24fw/24FW-23.jpg" alt="2024FW 封面" />
      <p>{{ $t('news.fw2024.content27') }}</p>
      <p>{{ $t('news.fw2024.content28') }}</p>

      <div class="back">
        <router-link to="/news" class="back-button">
          <span class="arrow">←</span> 返回 / return
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'News2024FW' }
</script>

<style scoped>
.news-detail-page {
  background: black;
  color: white;
  padding-bottom: 60px;
}

/* 顶部 hero 与 NewsHKListing 一致 */
.news-hero {
  position: relative;
  height: 230px;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
}
.news-hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
}
.hero-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 0 20px;
  white-space: nowrap;
}
.hero-text h1 {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  display: inline-block;
}
.en-title {
  display: inline;
  font-size: 20px;
  font-weight: normal;
  margin-left: 8px;
  letter-spacing: 0.5px;
  color: #ffb100;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.news-detail-content {
  max-width: 900px;
  margin: 40px auto;
  padding: 0 20px;
}
.news-detail-content h2 {
  color: #ffb100;
  font-size: 26px;
  margin-bottom: 40px;
  text-align: center;
  padding: 0 20px;
}
.news-detail-content .meta {
  font-size: 13px;
  color: #aaa;
  margin-bottom: 20px;
  text-align: center;
}
.news-detail-content p {
  line-height: 1.8;
  margin-bottom: 15px;
  text-align: justify;
  text-indent: 2em;
  font-size: 16px;
}
.news-detail-content img {
  width: 100%;
  margin: 20px 0;
  border-radius: 8px;
}
.minor { color: #ffb100; margin: 16px 0; text-align: center; }
.back {
  margin-top: 40px;
  text-align: center;
}
.back-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 24px;
  background-color: #000;
  color: #ffb100;
  border: 1px solid #ffb100;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  min-width: 120px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.back-button:hover {
  background-color: #ffb100;
  color: #000;
  border-color: #000;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(255, 179, 0, 0.2);
}
.back-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(255, 179, 0, 0.2);
}
.arrow { margin-right: 8px; font-size: 18px; }

/* 移动端适配 */
@media (max-width: 768px) {
  .news-hero { height: 180px; }
  .hero-text h1 { font-size: 18px; }
  .news-detail-content { max-width: 100%; margin: 20px 10px; padding: 0 10px; }
  .news-detail-content h2 { font-size: 22px; }
  .news-detail-content .meta { font-size: 12px; }
  .news-detail-content p { font-size: 14px; }
  .news-detail-content img { margin: 10px 0; }
  .back-button { padding: 8px 18px; font-size: 14px; }
}
</style>


